import styled, { css } from "styled-components";
import { useState } from "react";

const Container = styled.div`
  font-family: "Larsseit", "Roboto", sans-serif;
  font-size: 0.75em;
  width: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
`;

const openMenuMixin = css`
  transform: translateY(0);
  opacity: 1;
  pointer-events: all;
`;

const Links = styled.div`
  pointer-events: none;
  position: fixed;
  transform: translateY(0);
  left: 0;
  width: 100vw;
  background: #286dd6;
  overflow: hidden;
  transition: 0.3s;
  height: 100vh;
  box-sizing: border-box;
  opacity: 0;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  text-align: center;
  text-indent: -1em;
  ${(props) => (props.open ? openMenuMixin : "")}
`;

const Link = styled.a`
  color: white;
  font-size: 10vw;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, #00a5a5, #00a5a5);
  background-size: 0 1px;
  background-repeat: repeat-y;
  transition: 0.3s;

  &:active {
    background-size: 100% 1px;
  }
`;

const HamburgerButton = styled.button`
  width: 60px;
  height: 170px;
  border: none;
  background-color: transparent;
  background-image: ${(props) =>
    props.open ? "none" : "url(img/decorator-1.png)"};
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
  transition: 0.3s;
  position: absolute;
  top: 0;
  left: calc(100% - 60px);
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

const HamburgerIcon = styled.div`
  display: grid;
  gap: 3px;
  width: 30px;
  height: 30px;
  margin-top: 2em;
  transition: 0.3s;
  transform: ${(props) => (props.open ? "rotate(90deg)" : "rotate(0deg)")};
`;

const HamburgerLine = styled.span`
  height: 3px;
  background: white;
  border-radius: 3px;
`;

export function NavigationMobile({ links, active }) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <Container>
      <Links open={navOpen}>
        {links.map(({ id, name, url }) => (
          <Link href={url} className={active === url && "active"} key={id}>
            {name}
          </Link>
        ))}
      </Links>
      <Hamburger onClick={() => setNavOpen(!navOpen)} open={navOpen} />
    </Container>
  );
}

const Hamburger = ({ open, ...props }) => (
  <HamburgerButton open={open} {...props}>
    <HamburgerIcon open={open}>
      <HamburgerLine />
      <HamburgerLine />
      <HamburgerLine />
    </HamburgerIcon>
  </HamburgerButton>
);
